const DAY_IDS = ["domingo", "lunes", "martes", "miercoles", "jueves", "viernes", "sabado"];
const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const parseMinutes = (value) => {
  if (typeof value !== "string") return null;
  const match = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(value.trim());
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  return hours <= 23 && minutes <= 59 ? hours * 60 + minutes : null;
};

export const getPromotionClock = (date = new Date(), timeZone) => {
  if (!Number.isFinite(date.getTime())) return null;
  if (!timeZone) {
    const pad = (value) => String(value).padStart(2, "0");
    return {
      dayIndex: date.getDay(),
      dateKey: `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
      minutes: date.getHours() * 60 + date.getMinutes(),
    };
  }

  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-US", {
    timeZone, weekday: "short", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(date).map((part) => [part.type, part.value]));
  return {
    dayIndex: WEEKDAYS.indexOf(parts.weekday),
    dateKey: `${parts.year}-${parts.month}-${parts.day}`,
    minutes: Number(parts.hour) * 60 + Number(parts.minute),
  };
};

export const isPromotionAvailableAtClock = (promotion, clock) => {
  if (!clock || clock.dayIndex < 0 || clock.dayIndex > 6) return false;
  if (
    String(promotion?.comboKind || "").trim().toLowerCase() === "daily_menu" &&
    String(promotion?.dailyMenuDate || "").trim() !== clock.dateKey
  ) return false;

  const schedule = (Array.isArray(promotion?.schedule) ? promotion.schedule : [])
    .filter((day) => day?.active === true && DAY_IDS.includes(day.id));
  if (!schedule.length) return true;

  const today = schedule.find((day) => day.id === DAY_IDS[clock.dayIndex]);
  const yesterday = schedule.find((day) => day.id === DAY_IDS[(clock.dayIndex + 6) % 7]);

  if (today) {
    if (today.allDay === true) return true;
    const opening = parseMinutes(today.apertura);
    const closing = parseMinutes(today.cierre);
    // Preserve existing unrestricted-day behavior for incomplete or equal times.
    if (opening === null || closing === null || opening === closing) return true;
    if (closing > opening) {
      if (clock.minutes >= opening && clock.minutes < closing) return true;
    } else if (clock.minutes >= opening) {
      return true;
    }
  }

  // The after-midnight portion belongs to yesterday, even when today is disabled.
  if (!yesterday || yesterday.allDay === true) return false;
  const opening = parseMinutes(yesterday.apertura);
  const closing = parseMinutes(yesterday.cierre);
  return opening !== null && closing !== null && closing < opening && clock.minutes < closing;
};
